import { Badge, Box, Text } from '@chakra-ui/react';
import DataTableCard from './DataTableCard';
import { useBinderCardColors } from '../hooks/useBinderCardColors';
import ValidationBadge from './ValidationBadge';

interface TypeOfFuelCardProps {
  data?: any;
}

const TypeOfFuelCard = ({ data }: TypeOfFuelCardProps) => {
  const colors = useBinderCardColors();

  // Get processed vehicles data
  const vehicles = data?.vehicles || [];

  const formatFuelType = (fuelType: string) => {
    if (fuelType === 'Not specified') {
      return (
        <Badge colorScheme="gray" variant="outline" fontSize="xs">
          Not specified
        </Badge>
      );
    }

    // Wrap fuel type in info badge
    return (
      <Badge colorScheme="blue" variant="outline" fontSize="xs">
        {fuelType}
      </Badge>
    );
  };

  // Create table rows from processed vehicle data
  const vehicleRows = vehicles.map((vehicle: any) => {
    return [
      vehicle.name,
      formatFuelType(vehicle.fuelType),
      vehicle.remarks ? (
        <Text fontSize="sm">{vehicle.remarks}</Text>
      ) : (
        <Text fontSize="xs" color="gray.500" fontStyle="italic">
          No remarks
        </Text>
      ),
      <ValidationBadge status={vehicle.isValid ? 'pass' : 'caution'} />,
    ];
  });

  const headers = ['Vehicle', 'Type of Fuel', 'Remarks', 'Outcome'];

  // Handle empty state
  if (vehicleRows.length === 0) {
    return (
      <Box p={4} borderRadius="md" bg={colors.emptyFieldBgColor}>
        <Text color="gray.500" fontStyle="italic" textAlign="center">
          No vehicle data available
        </Text>
      </Box>
    );
  }

  return (
    <DataTableCard
      description="Record the type of fuel used by each vehicle."
      headers={headers}
      rows={vehicleRows}
    />
  );
};

export default TypeOfFuelCard;
